"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  :root {\n    --highlight-orange: ", ";\n    --highlight-red: ", ";\n    --highlight-green: ", ";\n    --highlight-blue: ", ";\n  }\n\n  .marker-orange { background: ", " !important; }\n  .marker-red { background: ", " !important; }\n  .marker-green { background: ", " !important; }\n  .marker-blue { background: ", " !important; }\n  .pen-orange { color: var(--highlight-orange) !important; }\n  .pen-red { color: var(--highlight-red) !important; }\n  .pen-blue { color: var(--highlight-blue) !important; }\n  .pen-green { color: var(--highlight-green) !important; }\n  mark {\n    background: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichText = void 0;

var polished_1 = require("polished");

var styled_components_1 = require("styled-components");

exports.RichText = (0, styled_components_1.createGlobalStyle)(_templateObject(), function (props) {
  return props.theme['@orange'];
}, function (props) {
  return props.theme['@red'];
}, function (props) {
  return props.theme['@green'];
}, function (props) {
  return props.theme['@blue'];
}, function (props) {
  return (0, polished_1.transparentize)(0.7, props.theme['@orange']);
}, function (props) {
  return (0, polished_1.transparentize)(0.7, props.theme['@red']);
}, function (props) {
  return (0, polished_1.transparentize)(0.7, props.theme['@green']);
}, function (props) {
  return (0, polished_1.transparentize)(0.7, props.theme['@blue']);
});